export default "__VITE_ASSET___fapCS6o__"